import { defineLiveHandler, resourceTag, type LiveHandler } from '@krp/client-runtime'

import { MINE_TAG, PLATFORM_RESOURCE_TAG } from './resourcesApi'

/** Общие типы событий ресурса (договор с `LiveEventTypes` в Resource.Contracts). */
export const RESOURCE_LIVE_EVENTS = {
  connectionChanged: 'resource.connection.changed',
} as const

/**
 * Связь с источником изменилась (SRC-HEALTH; служба вида публикует при смене состояния `ok` ↔ `error`): перечитать
 * «мои ресурсы» (оттуда `contact` полосы «Источник», плиток и точки «Связь») и карточку этого ресурса — без перезагрузки
 * раздела (RP-UI-LINK, шаг 3). Нагрузку события не разбираем: канал — подсказка, данные читаются REST. Область ресурса
 * (`resourceScopeTag`) не трогаем: смена связи не меняет данных источника, а перечитывать их все было бы дорого.
 * После переподключения перечитываются ресурсы Platform: за обрыв событие могло потеряться.
 */
export const platformLiveHandlers: readonly LiveHandler[] = [
  defineLiveHandler({
    type: RESOURCE_LIVE_EVENTS.connectionChanged,
    invalidates: (envelope) =>
      envelope.resourceId === null ? [MINE_TAG] : [MINE_TAG, resourceTag(PLATFORM_RESOURCE_TAG, envelope.resourceId, 'SUMMARY')],
    resync: [PLATFORM_RESOURCE_TAG],
  }),
]
